export function createPartnerCredentialClient(transport) {
    return {
        /**
         * List this tenant's partner credentials, as a mask and a state
         *
         * Requires scope: partner-credentials:summary:read
         */
        listTenantPartnerCredentialSummaries(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/partner-credentials",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * List every tenant's partner credentials, as a mask and a state
         *
         * Requires scope: partner-credentials:platform:read
         */
        listPlatformPartnerCredentialSummaries(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/partner-credentials",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/partners/{partnerId}/credentials
         *
         * Requires scope: partner-credentials:issue
         */
        issuePartnerCredential(tenantId, partnerId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/partners/${encodeURIComponent(partnerId)}/credentials`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/partners/{partnerId}/credentials/{credentialId}/transitions
         *
         * Requires scope: partner-credentials:approve
         */
        transitionPartnerCredential(tenantId, partnerId, credentialId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/partners/${encodeURIComponent(partnerId)}/credentials/${encodeURIComponent(credentialId)}/transitions`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/partners/{partnerId}/credentials/introspect
         *
         * Requires scope: partner-credentials:introspect
         */
        introspectPartnerCredential(tenantId, partnerId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/partners/${encodeURIComponent(partnerId)}/credentials/introspect`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=partner-credential.js.map